var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              attrs: { filterable: "", clearable: "", placeholder: "App名称" },
              model: {
                value: _vm.searchData.platform,
                callback: function($$v) {
                  _vm.$set(_vm.searchData, "platform", $$v)
                },
                expression: "searchData.platform"
              }
            },
            _vm._l(_vm.appList, function(item, index) {
              return _c("el-option", {
                key: item.id,
                attrs: { label: item.name, value: item.name }
              })
            }),
            1
          ),
          _vm._v(" "),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "通知邮箱", clearable: "" },
            model: {
              value: _vm.searchData.address,
              callback: function($$v) {
                _vm.$set(_vm.searchData, "address", $$v)
              },
              expression: "searchData.address"
            }
          }),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.fetchFeedbackList }
            },
            [_vm._v("查询")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-refresh" },
              on: { click: _vm.onClickReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: {
                click: function($event) {
                  _vm.showAdd = true
                }
              }
            },
            [_vm._v("新增")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.tableData,
            border: "",
            stripe: "",
            "highlight-current-row": ""
          }
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", label: "序号", width: "100" }
          }),
          _vm._v(" "),
          _vm._l(_vm.tableColumn, function(item, index) {
            return [
              _c("el-table-column", {
                key: index,
                attrs: {
                  label: item.label,
                  formatter: item.formatter,
                  prop: item.prop
                }
              })
            ]
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.editItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("编辑")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger", size: "mini" },
                        on: {
                          click: function($event) {
                            return _vm.delItem(scope.row)
                          }
                        }
                      },
                      [_vm._v("删除")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.pageData.total > 0,
                expression: "pageData.total > 0"
              }
            ],
            attrs: {
              "current-page": _vm.pageData.page,
              "page-sizes": [10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
              "page-size": _vm.pageData.rows,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pageData.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showAdd,
            width: "500px",
            title: _vm.feedbackForm.id ? "编辑" : "新增",
            closeable: ""
          },
          on: {
            "update:visible": function($event) {
              _vm.showAdd = $event
            },
            open: _vm.onAddDialogOpen,
            close: _vm.onAddDialogClose
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "feedbackForm",
              attrs: {
                rules: _vm.feedbackRule,
                "validate-on-rule-change": false,
                "label-width": "120",
                model: _vm.feedbackForm
              }
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "通知类型", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择反馈通知类型"
                      },
                      model: {
                        value: _vm.feedbackForm.type,
                        callback: function($$v) {
                          _vm.$set(_vm.feedbackForm, "type", $$v)
                        },
                        expression: "feedbackForm.type"
                      }
                    },
                    _vm._l(_vm.typeList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "App名称(AppId)", prop: "platform" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        clearable: "",
                        placeholder: "请选择App(单选)"
                      },
                      model: {
                        value: _vm.feedbackForm.platform,
                        callback: function($$v) {
                          _vm.$set(_vm.feedbackForm, "platform", $$v)
                        },
                        expression: "feedbackForm.platform"
                      }
                    },
                    _vm._l(_vm.appList, function(item, index) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.name }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "收件人邮箱", prop: "address" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请填写收件人通知邮箱(可多个，以;分隔)",
                      type: "textarea",
                      rows: "5"
                    },
                    on: { blur: _vm.onAddressBlur },
                    model: {
                      value: _vm.feedbackForm.address,
                      callback: function($$v) {
                        _vm.$set(_vm.feedbackForm, "address", $$v)
                      },
                      expression: "feedbackForm.address"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "备注", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请填写",
                      type: "textarea",
                      rows: "5"
                    },
                    model: {
                      value: _vm.feedbackForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.feedbackForm, "remark", $$v)
                      },
                      expression: "feedbackForm.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onSaveFeedback }
                    },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }